import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import useNativeListener from '@hooks/useNativeListener';
import { Permission } from '@models/permission';
import { useQuery } from '@tanstack/react-query';
import NativeUtil from '@utils/NativeUtil';
import { useAtom, useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';

import { locationAgreedAtom, userLatLonAtom } from '../atoms/shopsInMapAtoms';

interface ILocation {
    lat: number,
    lon: number,
}

function useLocation() {
  const toast = useToast();
  const [locationAgreed, setLocationAgreed] = useAtom(locationAgreedAtom);
  const setLocation = useSetAtom(userLatLonAtom);
  const [ready, setReady] = useState<boolean>(false);
  const { data: user } = useQuery(queries.user.detail());

  useNativeListener('getLocation', (result: ILocation) => {
    console.log('getLocation', { result });
    if (result && (user?.locationAgreed || !user)) {
      setLocation(result);
    }
    setLocationAgreed(!!result && (!!user?.locationAgreed || !user));
    setReady(true);
  }, [user]);

  useNativeListener('checkPermission', (permission: Permission, hasPermission: boolean) => {
    console.log('checkPermission', { permission, hasPermission });
    if (user?.locationAgreed || !user) {
      if (permission === Permission.LOCATION && hasPermission) {
        NativeUtil.postMessage('getLocation', '');
      } else {
        NativeUtil.postMessage('requestPermission', Permission.LOCATION);
      }
    }
  }, [user]);

  useNativeListener('requestPermission', (permission: Permission, result: boolean) => {
    console.log('requestPermission', { permission, result });
    if (permission === Permission.LOCATION) {
      setLocationAgreed(result);
      toast.success(result ? '위치 권한이 허용되었습니다.' : '위치 권한이 거부되었습니다.');
      NativeUtil.postMessage('getLocation', '');
    }
  });

  useEffect(() => {
    if (!user) {
      NativeUtil.postMessage('checkPermission', Permission.LOCATION);
    } else if (user.locationAgreed) {
      NativeUtil.postMessage('checkPermission', Permission.LOCATION);
    } else {
      setLocationAgreed(false);
      setReady(true);
    }
  }, [user]);

  return {
    locationAgreed, ready,
  };
}

export default useLocation;
